import React from "react";
import swanLogo from "../../assets/branding/swan-logo.png";

function getStepClassName(state = "pending") {
    if (state === "complete") {
        return "secure-launch-step is-complete";
    }

    if (state === "active") {
        return "secure-launch-step is-active";
    }

    return "secure-launch-step";
}

export default function SecureLaunchExperience({
    eyebrow = "Secure handoff",
    title,
    description,
    portalLabel,
    note = "Keep this window open while we prepare the secure handoff.",
    launching = false,
    steps = [],
}) {
    return (
        <main className={`secure-launch-stage ${launching ? "is-launching" : ""}`}>
            <div className="secure-launch-stage__backdrop" aria-hidden="true">
                <span className="secure-launch-stage__glow secure-launch-stage__glow--left" />
                <span className="secure-launch-stage__glow secure-launch-stage__glow--right" />
                <span className="secure-launch-stage__glow secure-launch-stage__glow--center" />
            </div>

            <section className="secure-launch-stage__content" aria-live="polite" aria-busy="true">
                <div className="secure-launch-stage__eyebrow">{eyebrow}</div>

                <div className="secure-launch-orb" aria-hidden="true">
                    <div className="secure-launch-orb__ring secure-launch-orb__ring--outer" />
                    <div className="secure-launch-orb__ring secure-launch-orb__ring--inner" />
                    <div className="secure-launch-orb__pulse" />
                    <div className="secure-launch-orb__core">
                        <img src={swanLogo} alt="" className="secure-launch-orb__logo" />
                    </div>
                </div>

                <div className="secure-launch-stage__copy">
                    {portalLabel ? <div className="secure-launch-stage__portal">{portalLabel}</div> : null}
                    <h1 className="secure-launch-stage__title">{title}</h1>
                    <p className="secure-launch-stage__description">{description}</p>

                    {steps.length > 0 ? (
                        <div className="secure-launch-steps" role="list" aria-label="Launch progress">
                            {steps.map((step) => (
                                <div key={step.label} className={getStepClassName(step.state)} role="listitem">
                                    <span className="secure-launch-step__dot" aria-hidden="true" />
                                    <span>{step.label}</span>
                                </div>
                            ))}
                        </div>
                    ) : null}

                    <p className="secure-launch-stage__note">{note}</p>
                </div>
            </section>
        </main>
    );
}
